// Section transition lines - minimal, clean
export const TransitionLine = ({ text }) => (
  <div className="py-10 lg:py-14 bg-[#0A0A0A]">
    <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
      <p className="text-lg text-zinc-400 italic leading-relaxed">
        {text}
      </p>
    </div>
  </div>
);

export default TransitionLine;
